import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-3 row justify-content-center"
}
const _hoisted_2 = {
  class: "no-screen table",
  cellpadding: 5
}
const _hoisted_3 = { class: "py-3" }

import Api from '@/services/api';
    import { Travel, TravelTicket } from '@/services/types';
    import { ElTableColumn, ElIcon, ElMessage, FormInstance, ElDescriptions, ElDescriptionsItem, ElButton } from 'element-plus';
    import { nextTick, onBeforeMount, reactive, ref } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import PersonalTable from '@/components/PersonalTable.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TravelInfoVIew',
  setup(__props) {

    const route = useRoute()
    const id = route.params.id

    const router = useRouter()
    const back = () => {
        router.push("/companies-dashboard/travel")
    }
    const loading = ref<boolean>(true)
    const error = ref<boolean>(false)
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const tickets = ref<Array<TravelTicket>>([])

    const travel = reactive<Travel>({
        car_id: 0,
        departure: new Date(),
        route_id: 0,
        active: 1,
        remaining_places: []
    })

    const print = () => {
        window.print()
        console.log("Printing")
        nextTick()
    }

    const password = sessionStorage.getItem('password')
    const phone = sessionStorage.getItem('phone')

    const getTrip = async (id: number | string) => {
        const res = await Api.get(`companies/travel/${id}?password=${password}&phone=${phone}`)
        if (res.status == 200) {
            const data = res.data.trip
            travel.active = true
            travel.car = data.car
            travel.car_id = data.car_id
            travel.departure = data.departure
            travel.id = data.id
            travel.remaining_places = data.remaining_places
            travel.route = data.route
            travel.route_id = data.route_id
            travel.user = data.user
    
            error.value = false
            console.log(data)
        } else {
            error.value = true
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }
    
    const getTickets = async (id: number | string) => {
        const res = await Api.get(`companies/tickets/${id}?password=${password}&phone=${phone}`)
        if (res.status == 200) {
            console.log(res)
            tickets.value = res.data.tickets
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }

    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getTrip(id as string),
            getTickets(id as string)
        ])
        // await getCars(travel.car?.travel_company_id as number)
        loading.value = false
    })

return (_ctx: any,_cache: any) => {
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ElText = _resolveComponent("ElText")!
  const _component_Printer = _resolveComponent("Printer")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (!error.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_card, {
          class: "col-12 print-sheet",
          header: travel.id ? `Viagem ${travel.id}`:'Procurando Viagem'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_skeleton, {
              loading: loading.value,
              animated: "",
              rows: 12
            }, {
              default: _withCtx(() => [
                travel
                  ? (_openBlock(), _createBlock(_component_el_form, {
                      key: 0,
                      disabled: saving.value,
                      model: travel,
                      "label-position": "top",
                      ref_key: "formRef",
                      ref: formRef
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElDescriptions), {
                          class: "margin-top",
                          title: "Detalhes da viagem",
                          column: 3,
                          size: 'default',
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElDescriptionsItem), null, {
                              label: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("div", { class: "cell-item" }, " Empresa ", -1)
                              ]))]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(travel.car?.travel_company?.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElDescriptionsItem), null, {
                              label: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("div", { class: "cell-item" }, " Data e Hora de partida ", -1)
                              ]))]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(new Date(travel.departure).toLocaleString()), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElDescriptionsItem), null, {
                              label: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("div", { class: "cell-item" }, " Lugares restantes ", -1)
                              ]))]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(travel.remaining_places?.length), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElDescriptionsItem), null, {
                              label: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("div", { class: "cell-item" }, " Rota definida ", -1)
                              ]))]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(travel.route?.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElDescriptionsItem), null, {
                              label: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("div", { class: "cell-item" }, " Carro ", -1)
                              ]))]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(travel.car?.name) + " [" + _toDisplayString(travel.car?.plate) + "] ", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElDescriptionsItem), null, {
                              label: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("div", { class: "cell-item" }, " Capacidade do Carro ", -1)
                              ]))]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(travel.car?.places) + " lugares ", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled", "model"]))
                  : _createCommentVNode("", true),
                _cache[9] || (_cache[9] = _createElementVNode("h5", null, "Passageiros", -1)),
                _createVNode(PersonalTable, {
                  class: "no-print",
                  loading: loading.value,
                  height: 450,
                  showRows: 10,
                  cols: [
                        {label: 'Cod', prop: 'id'},
                        {label: 'Passageiro', prop: 'name'},
                        {label: 'Cadeira Nr', prop: 'place'},
                        {label: 'Preço (MT)', prop: 'price'},
                    ],
                  data: tickets.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElTableColumn), {
                      label: "Data de nascimento",
                      "class-name": "auto",
                      "min-width": 150
                    }, {
                      default: _withCtx((data) => [
                        _createTextVNode(_toDisplayString(new Date(data.row.birthday).toLocaleDateString("af")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElTableColumn), {
                      label: "Viagem",
                      "class-name": "auto",
                      "min-width": 150
                    }, {
                      default: _withCtx((data) => [
                        _createVNode(_component_ElText, {
                          type: "success",
                          style: {"text-align":"right"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.row.trip_segment.from?.name) + " - " + _toDisplayString(data.row.trip_segment.to?.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading", "data"]),
                _createElementVNode("table", _hoisted_2, [
                  _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Code"),
                      _createElementVNode("th", null, "Nome do passageiro"),
                      _createElementVNode("th", null, "Cadeira"),
                      _createElementVNode("th", null, "Origem - Destino"),
                      _createElementVNode("th", null, "Data e hora da compra")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tickets.value, (ticket) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: ticket.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(ticket.id), 1),
                        _createElementVNode("td", null, _toDisplayString(ticket.name), 1),
                        _createElementVNode("td", null, _toDisplayString(ticket.place), 1),
                        _createElementVNode("td", null, _toDisplayString(ticket.trip_segment?.from?.name) + " - " + _toDisplayString(ticket.trip_segment?.to?.name), 1),
                        _createElementVNode("td", null, _toDisplayString(new Date(ticket.created_at ?? 0).toLocaleString('af')), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(ElButton), {
                    class: "no-print",
                    type: 'primary',
                    plain: "",
                    onClick: print
                  }, {
                    default: _withCtx(() => [
                      _cache[7] || (_cache[7] = _createElementVNode("span", null, "Imprimir lista  ", -1)),
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Printer)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ElButton), {
                    class: "no-print",
                    type: 'primary',
                    plain: "",
                    onClick: back
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ArrowLeft)
                        ]),
                        _: 1
                      }),
                      _cache[8] || (_cache[8] = _createTextVNode(" Voltar ", -1))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["header"])
      ]))
    : _createCommentVNode("", true)
}
}

})